<div class="srIrops-itinerary srIrops-cancelItinerary" style="margin-top: 30px;">
  <div class="srIrops-newItinerary">
    <div class="srIrops-textNewItinerary text-am-white fs-24px fw-regular lh-30px">
      <h3>
        {{ "srIrops.itinerary" | translate }}
      </h3>
    </div>
    <div class="srIrops-tagCancelled">
      <div class="text-am-white fs-20px fw-medium-x lh-28px">
        {{ "srIrops.cancelled" | translate }}
      </div>
    </div>
  </div>
  <div class="srIrops-separatorLine" style="height: 100px;"></div>
  <div class="srIrops-routeOriginDestination">
    <div class="srIrops-origin">
      <span class="srIrops-originDate text-am-white fs-24px fw-regular lh-34px">
        {{ segment?.departureDateTime | localizedDate:'dd MMM' | titlecase }}
      </span>
      <div class="srIrops-originHour">
        <div class="srIrops-textCancel fs-32px fw-medium-x lh-42px">
          <span>
            {{ segment?.departureDateTime | date:'HH:mm' }}
          </span>
        </div>
      </div>
      <div class="srIrops-originDeparture text-am-white fs-24px fw-regular lh-34px">
        <span>
          {{ departureAirport }}
        </span>
      </div>
    </div>
    <div class="srIrops-lineRoute">
      <div class="srIrops-pointOrigin srIrops-isCancelled">
      </div>
      <div class="srIrops-lineOne srIrops-isCancelled">
      </div>

      <div class="srIrops-lineTwo srIrops-isCancelled">
      </div>
      <div class="srIrops-pointDestination srIrops-isCancelled">
      </div>
    </div>
    <div class="srIrops-destination">
      <span class="srIrops-destinationDate text-am-white fs-24px fw-regular lh-34px">
        {{ segment?.arrivalDateTime | localizedDate:'dd MMM' | titlecase }}
      </span>
      <div class="srIrops-destinationHour srIrops-textCancel fs-32px fw-medium-x lh-42px">
        <span>
          {{ segment?.arrivalDateTime | date:'HH:mm' }}
        </span>
      </div>
      <div class="srIrops-destinationDeparture text-am-white fs-24px fw-regular lh-34px">
        <span>
          {{ arrivalAirport }}
        </span>
      </div>
    </div>
  </div>
</div>